import React from 'react';
import ImageTextContent from 'components/commercetools-ui/atoms/image-text-content';
import Breadcrumb from 'components/commercetools-ui/atoms/breadcrumb';
import { HomeIcon } from '@heroicons/react/24/outline';
import { ChevronRightIcon } from '@heroicons/react/24/solid';
import Link from 'components/commercetools-ui/atoms/link';
import ImageHTMLContent from 'components/commercetools-ui/atoms/image-html-content';
import { useParams } from 'next/navigation';

export interface ExperienceCenterLocationSpecificProps {
  data: any;
}


type componentType = { section_with_image_text: any; section_with_video: any };
const ExperienceCenterLocationSpecific: React.FC<ExperienceCenterLocationSpecificProps> = ({ data }) => {
  const { locale } = useParams();


  return (
    <div className=" w-full">
      <div className="hidden px-24 pb-8 pt-16 md:block lg:px-32 md:px-12 xl:px-44 2xl:px-64">
        <Breadcrumb Separator={<ChevronRightIcon className="mt-2 w-16" />} listClassName="!gap-x-16">
          <Link link={'/'}>
            <HomeIcon className="mt-6 w-20" />
          </Link>

          {/* When we are in NZ, even if the user clicks on 'Experience Centre,' it should not redirect anywhere. However, for AU, it should redirect to Australia locations. */}
          {locale && locale === 'nz' ? (
            [
            <span key='1' className="text-14 font-normal leading-4 text-[#090909]">About Us</span>,
            <span key='2' className="text-14 font-normal leading-4 text-[#090909]">Support</span>,
            <span key='3' className="text-14 font-normal leading-4 text-[#090909]">Experience Centres</span>
            ]
          ) :           
            <Link link={'/experience-centres/'}>
              <span className="text-12 font-normal leading-4 text-[#090909]">Experience Centres</span>
            </Link>
          }

          {/* <span className="text-12 font-normal leading-4 text-[#666]">{data?.components?.[0]?.section_with_image_text?.title}</span> */}
        </Breadcrumb>
      </div>
      <div className="flex flex-col gap-y-48 xl:gap-y-50 2xl:gap-y-80">
        {data?.components?.map((component: componentType, index: number) => (
          <div key={index}>
            {component?.section_with_image_text && (
              <div className={index === 0 || index === data?.components.length - 1 ? '' : 'md:px-28 xl:px-72 2xl:px-208'}>
                <ImageTextContent data={component?.section_with_image_text} index={index} totalSections={data?.components?.length}/>
              </div>
            )}
            {component?.section_with_video && (
              <div className="md:px-100 2xl:px-208">
                <ImageHTMLContent data={component?.section_with_video} />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
export default ExperienceCenterLocationSpecific;